export default {
  en: {
    changePassword: {
      enterEmailLabel: "Enter account email",
      emailPlaceholder: "Account email",
      requestCodeButton: "Request validation code",
      enterCodeLabel: "Enter validation code",
      codePlaceholder: "Code",
      checkSpam: "Please check your spam folder if a code doesn't arrive in a few minutes.",
      requestAnotherCodeLink: "Request another code",
      newPasswordLabel: "New password",
      newPasswordPlaceholder: "Password",
      confirmPasswordLabel: "Confirm new password",
      confirmPasswordPlaceholder: "Confirm password",
      changePasswordButton: "Change password",
      passwordChangedTitle: "Password changed",
      passwordChangedMessage: "Your password has been successfully changed.",
      continueButton: "Continue",
      errorRequestLimit: "Email validation request limit exceeded.",
      errorRequestWait: "Please wait at least 30 seconds for the validation email to arrive.",
      errorRequestCodeTitle: "Error requesting validation code",
      errorRequestCodeMessage: "There was a problem generating the authentication code. <br/>{error}",
      errorChangePasswordTitle: "Error changing password",
      errorChangePasswordMessage: "There was a problem changing the password. <br/>{error}",
    },
  },
  de: {
    changePassword: {
      enterEmailLabel: "E-Mail-Adresse eingeben",
      emailPlaceholder: "E-Mail-Adresse",
      requestCodeButton: "Validierungscode anfordern",
      enterCodeLabel: "Validierungscode eingeben",
      codePlaceholder: "Code",
      checkSpam: "Bitte überprüfen Sie Ihren Spam-Ordner, falls der Code nicht innerhalb weniger Minuten ankommt.",
      requestAnotherCodeLink: "Einen weiteren Code anfordern",
      newPasswordLabel: "Neues Passwort",
      newPasswordPlaceholder: "Passwort",
      confirmPasswordLabel: "Neues Passwort bestätigen",
      confirmPasswordPlaceholder: "Passwort bestätigen",
      changePasswordButton: "Passwort ändern",
      passwordChangedTitle: "Passwort geändert",
      passwordChangedMessage: "Ihr Passwort wurde erfolgreich geändert.",
      continueButton: "Weiter",
      errorRequestLimit: "E-Mail-Validierungsanforderungslimit überschritten.",
      errorRequestWait: "Bitte warten Sie mindestens 30 Sekunden, bis die Validierungs-E-Mail eintrifft.",
      errorRequestCodeTitle: "Fehler beim Anfordern des Validierungscodes",
      errorRequestCodeMessage: "Es gab ein Problem beim Generieren des Authentifizierungscodes. <br/>{error}",
      errorChangePasswordTitle: "Fehler beim Ändern des Passworts",
      errorChangePasswordMessage: "Es gab ein Problem beim Ändern des Passworts. <br/>{error}",
    },
  },
};
